import { router } from "@inertiajs/react";
import { Sparkles } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from "@/components/ui/item";
import { useOrganizationRoutes } from "@/hooks/use-organization-routes";

interface MatchAICardProps {
  deliveryNoteId: number;
  hasPurchaseRequest: boolean;
  isProcessing: boolean;
  hasUnassignedItems: boolean;
}

export default function MatchAICard({
  deliveryNoteId,
  hasPurchaseRequest,
  isProcessing,
  hasUnassignedItems,
}: MatchAICardProps) {
  const [isMatching, setIsMatching] = useState(false);
  const routes = useOrganizationRoutes();

  const handleMatch = () => {
    setIsMatching(true);
    router.post(
      routes.deliveryNotes.matchItems(deliveryNoteId),
      {},
      {
        preserveScroll: true,
        onFinish: () => setIsMatching(false),
      },
    );
  };

  if (!hasPurchaseRequest) {
    return (
      <Item variant="outline" size="sm">
        <ItemMedia variant="icon">
          <Sparkles className="h-4 w-4" />
        </ItemMedia>
        <ItemContent>
          <ItemTitle>Match Inteligente de Ítems</ItemTitle>
          <ItemDescription>
            Vinculá primero una Solicitud de Compra para poder matchear ítems automáticamente
          </ItemDescription>
        </ItemContent>
      </Item>
    );
  }

  if (isProcessing) {
    return null;
  }

  return (
    <Item variant="outline" size="sm">
      <ItemMedia variant="icon">
        <Sparkles className="h-4 w-4" />
      </ItemMedia>
      <ItemContent>
        <ItemTitle>Match Inteligente de Ítems</ItemTitle>
        <ItemDescription>
          El sistema puede vincular automáticamente los ítems del remito con los de la solicitud de compra
        </ItemDescription>
      </ItemContent>
      <ItemActions>
        <Button
          onClick={handleMatch}
          disabled={isMatching || !hasUnassignedItems}
          size="sm"
        >
          {isMatching ? "Procesando..." : "Ejecutar Match IA"}
        </Button>
      </ItemActions>
    </Item>
  );
}
